import React from 'react';

const IconChevronLeft = () => (
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.5 16L1 8.5L8.5 1" stroke="currentColor" />
  </svg>
);

export default IconChevronLeft;
